import { createBlimoApi } from '@blimo/api-client';

export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? '', // leer = gleiche Herkunft (Vite-Proxy lokal)
  adminUrl: import.meta.env.VITE_ADMIN_URL ?? 'http://localhost:5173',
};

export const api = createBlimoApi({ baseUrl: env.apiUrl });
